module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Arvon on oltava ".concat(args.maxValue, " tai sit\xE4 aikaisempi.");
  },
  "rangeReversed": "Aloitusp\xE4iv\xE4n on oltava ennen lopetusp\xE4iv\xE4\xE4.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Arvon on oltava ".concat(args.minValue, " tai sit\xE4 my\xF6h\xE4isempi.");
  },
  "unavailableDate": "Valittu p\xE4iv\xE4m\xE4\xE4r\xE4 ei ole k\xE4ytett\xE4viss\xE4."
};